import { UntypedFormGroup } from '@angular/forms';
import { BusinessRepresentativeLabels } from '../business-representative-labels/business-representative-labels';

/**
 * Business representative form helper class
 */
export class BusinessRepresentativeFormObject {
  /**
   * @constructor
   */
  constructor(
    public formGroup: UntypedFormGroup,
    public labels: BusinessRepresentativeLabels,
    public termsAndConditionsLink?: string,
    public privacyPolicyLink?: string
  ) {}
}
